function addBackdrop() {
    if(document.querySelector('.backdrop')) {
        return; // Bail if page already has backdrop
    }

    const backdrop = document.createElement('div');
    backdrop.classList.add('backdrop');

    document.body.append(backdrop);
}

function removeBackdrop() {
    const backdrop = document.querySelector('.backdrop');

    if(!backdrop) {
        return;
    }

    backdrop.parentElement.removeChild(backdrop);
}